import { type CommonTranslationKeys } from '@/types/translation';
import { type SchoolType } from '@/views/build/type';

export const PublisherLabelMap: Record<string, string> = {
  DONGA: '동아출판',
  KUMSUNG: '금성출판사',
  VISANGEDU: '비상교육',
  JIHAK: '지학사',
  CHUNJAETEXT: '천재교과서',
  CHUNJAE: '천재교육',
  KYOHAK: '교학사',
  YBM: 'YBM',
  ISCREAMMEDIA: '아이스크림미디어',
  CMASS: '씨마스',
  NATIONAL: '국정 교과서',
  DAEKY: '대교',
  GIMMYOUNG: '김영사',
  VISANGTEXT: '비상교과서',
  MIRAEN: '미래엔',
  OTHER: '기타',
};

export const tSchoolLevelTKey: Record<SchoolType, CommonTranslationKeys> = {
  kindergarten: 'school.level.kindergarten',
  primary: 'school.level.primary',
  middle: 'school.level.middle',
  high: 'school.level.high',
  college: 'school.levelShort.college',
  other: 'school.level.other',
};
